import React from 'react'
import styled, { css } from "styled-components";
import { ReactComponent as Check } from "../../assets/svg/check.svg";

const ListTitles = (props: IListTitlesProps) => {
  return (
    <Container>
      {props.items.map((item) => {
        return (
          <Row
            key={item.id}
            allow={item.isEnabled}
            purchased={item.isPurchased}
            onClick={item.isEnabled ? () => props.onClick(item) : undefined}
          >
            <Title>{item.label}</Title>
            {item.isCompleted && <StateIcon as={Check} />}
          </Row>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px;
  box-sizing: border-box;

  border-width: 0px 5px 0px 0px;
  border-style: solid;
  border-color: transparent;

  ${(props: {
    purchased: boolean;
    allow: boolean;
  }) => props.purchased && css`
    border-color: #2196f3;
  `}

  ${(props: {
    purchased: boolean;
    allow: boolean;
  }) =>
    props.allow
      ? css`
          cursor: pointer;
          background-color: white;
        `
      : css`
          cursor: default;
          background-color: #f5f5f5;
          & > * {
            opacity: 0.5;
          }
        `}
`;

const Attempt = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ec407a;
  color: white;
  font-size: 0.7em;
  font-weight: 600;
`;

const StateIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
`;

const Title = styled.div`
  font-size: 0.9em;
  user-select: none;
`;

export default ListTitles;
